import { useProjectCustomFields } from '@/hooks/useProjectCustomFields';
import { useMemo } from 'react';

const useGetProjectFieldsets = () => {
  const { projectCustomFields, ...rest } = useProjectCustomFields();

  const projectFieldsets = useMemo(
    () => projectCustomFields.filter((field) => field.type === 'fieldset'),
    [projectCustomFields]
  );

  return {
    projectFieldsets,
    ...rest,
  };
};

export default useGetProjectFieldsets;
